/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreSoftDeleteProjectAttachmentDto } from '../../models/core-soft-delete-project-attachment-dto';

export interface ProjectsControllerSoftDeleteAttachment$Params {
  tenant: string;
  projectId: string;
      body: CoreSoftDeleteProjectAttachmentDto
}

export function projectsControllerSoftDeleteAttachment(http: HttpClient, rootUrl: string, params: ProjectsControllerSoftDeleteAttachment$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
  const rb = new CoreRequestBuilder(rootUrl, projectsControllerSoftDeleteAttachment.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as CoreStrictHttpResponse<void>;
    })
  );
}

projectsControllerSoftDeleteAttachment.PATH = '/o2-core/projects/{tenant}/{projectId}/attachments';
